(function () {
    let options = {
        autoplay: true,
        delay: 5000,
        loop: true,
        spaceBetween: 16,
        slidesPerView: 1,
        navigation : {
            nextEl : '.swiper__button-next',
            prevEl : '.swiper__button-prev'
        },
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            1000: {
                slidesPerView: 3
            }
        },
        pagination: {
            el: '.testimonials__dots',
            clickable: true
        }
    }

    const swiper = new Swiper('.testimonials__slider', options);
})()